import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useEffect, useState } from "react";
import { regexValidator } from "../../../../../utils/regexValidator";

interface Props {
  name: string;
  add: (param: string) => void;
  error: boolean;
  init: string;
}

export const Regex = ({ name, add, error, init }: Props) => {
  const [value, setValue] = useState(init);
  const [isValidRegex,setIsValidRegex] = useState<boolean>(() => {
    return regexValidator(init)
  })


  return (
    <>
      <label
        className={classNames({"p-error": error && value === "" || !isValidRegex,
        labelSourceExterne: true, })}
      >
        {name}<span className="star">*</span>
      </label>
      <InputText
        id={name}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setIsValidRegex(regexValidator(e.target.value))
          console.log(e.target.value,regexValidator(e.target.value))
          add(e.target.value);
        }}
        className={classNames({
          "p-invalid": error && value === "" || !isValidRegex,
          fieldSourceExt: true,
        })}
      />
     {!isValidRegex ? <div className="p-error">La regex est invalide</div> : null}
    </>
  );
};
